import React from 'react';
import ContactUsButton from '../components/ContactUsButton';

const SportPracticesRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Sport Practices</p>
          <h1 className="page-title">Sport Practices</h1>
          <p className="page-subtitle">
            Guidelines and information for scheduling regular practices at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Practices"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>Practice Scheduling</h2>
            <ul>
              <li>Practice times are scheduled in recurring blocks when possible.</li>
              <li>Teams and organizations must confirm start and end dates for their practice season.</li>
              <li>Any schedule changes should be communicated as early as possible.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Facility Usage</h2>
            <ul>
              <li>Groups must use only the spaces assigned to them for each practice.</li>
              <li>Setup and cleanup must be completed within the scheduled time.</li>
              <li>Coaches are responsible for ensuring the space is left in good condition.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Participants &amp; Safety</h2>
            <ul>
              <li>All participants should use appropriate footwear and equipment.</li>
              <li>Coaches must supervise practice activities at all times.</li>
              <li>Any injuries or incidents should be reported to facility staff.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SportPracticesRulesPage;


